import { DrinkVariant } from '@/config/drinkVariants';

interface NutritionSectionProps {
  currentVariant: DrinkVariant;
}

const NutritionSection = ({ currentVariant }: NutritionSectionProps) => {
  return (
    <section id="nutrition" className="py-24 md:py-32 bg-card relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, hsl(var(--primary)) 1px, transparent 0)`,
          backgroundSize: '32px 32px'
        }} />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="text-xs font-medium tracking-[0.3em] text-primary uppercase mb-4 block">
              Nutrition Facts
            </span>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl text-foreground mb-6">
              Clean<br />
              <span className="text-primary">Energy</span>
            </h2>
            <p className="text-muted-foreground mb-8 leading-relaxed text-lg">
              {currentVariant.nutritionDescription}
            </p>
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center">
                <span className="font-display text-2xl text-primary">{currentVariant.calories}</span>
              </div>
              <div>
                <p className="font-medium text-foreground">Calories per can</p>
                <p className="text-sm text-muted-foreground">{currentVariant.servingSize} of refreshment</p>
              </div>
            </div>
          </div>

          {/* Nutrition label card */}
          <div className="bg-background border-4 border-foreground p-6 max-w-sm mx-auto w-full">
            <h3 className="font-display text-4xl text-foreground border-b-8 border-foreground pb-2 mb-2">
              Nutrition Facts
            </h3>
            <p className="text-sm text-foreground border-b border-foreground pb-2 mb-2">
              Servings Per Container: 1
            </p>

            {currentVariant.nutritionFacts.map((fact, index) => (
              <div
                key={fact.label}
                className={`flex justify-between py-1 ${
                  index === 0 ? 'border-b-8 border-foreground' : 'border-b border-foreground/30'
                }`}
              >
                <span className={`text-foreground ${index === 0 ? 'font-bold' : ''}`}>
                  {fact.label}
                </span>
                <span className="font-bold text-foreground">
                  {fact.value}{fact.unit || ''}
                </span>
              </div>
            ))}

            <p className="text-xs text-muted-foreground mt-4">
              * Based on a 300ml serving size.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NutritionSection;
